// extracted by mini-css-extract-plugin
export default {"chat-list-container":"ChatsList_chat-list-container__cxX3Y","no-chats-msg":"ChatsList_no-chats-msg__5cF-P"};